import { AiVariantType, MelFields } from '../types';

export const aiVariantTypeMap: Record<MelFields, AiVariantType> = {
  [MelFields.BottomLine]: AiVariantType.Product,
  [MelFields.BuyingGuide]: AiVariantType.Page,
  [MelFields.Faqs]: AiVariantType.Product,
  [MelFields.Pros]: AiVariantType.Product,
  [MelFields.Summary]: AiVariantType.Product,
};

export const melFieldTitleMap: Record<MelFields, string> = {
  [MelFields.BottomLine]: 'Bottom Line',
  [MelFields.BuyingGuide]: 'Buying Guide',
  [MelFields.Faqs]: 'FAQs',
  [MelFields.Pros]: 'Pros',
  [MelFields.Summary]: 'Summary',
};
